export default __webpack_public_path__ + "5160e109b06db1a2890faf510d59d91a.png";